export const offerFilters = {
  none: 'none',
  local: 'local',
  nearMe: 'nearMe',
  expireSoon: 'expireSoon',
};

const filterParamNames = ['expireSoon', 'local', 'sort', 'radius', 'currentPage'];

export const getOfferFilterFromSearchParams = (searchParams) => {
  if (searchParams.get('expireSoon') === 'true') return offerFilters.expireSoon;
  if (searchParams.get('local') !== 'true') return offerFilters.none;
  return searchParams.get('sort') === 'distance' ? offerFilters.nearMe : offerFilters.local;
};

export const applyOfferFilterToSearchParams = (search, filter) => {
  const searchParams = new URLSearchParams(search);
  filterParamNames.forEach((name) => searchParams.delete(name));

  if (filter === offerFilters.local || filter === offerFilters.nearMe) {
    searchParams.set('local', 'true');
    searchParams.set('radius', '10');
  }
  if (filter === offerFilters.nearMe) {
    searchParams.set('sort', 'distance');
  }
  if (filter === offerFilters.expireSoon) {
    searchParams.set('expireSoon', 'true');
  }

  return searchParams;
};
